import { render, staticRenderFns } from "./dangerousGoodPackage.vue?vue&type=template&id=78875338&"
import script from "./dangerousGoodPackage.vue?vue&type=script&lang=js&"
export * from "./dangerousGoodPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78875338')) {
      api.createRecord('78875338', component.options)
    } else {
      api.reload('78875338', component.options)
    }
    module.hot.accept("./dangerousGoodPackage.vue?vue&type=template&id=78875338&", function () {
      api.rerender('78875338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/dangerousGoodPackage.vue"
export default component.exports